import { useDispatch } from 'react-redux'

import Grid from '@mui/material/Grid'

import { useGET_teacherProfileSelectQuery } from 'redux/api/teachersApi'

import { AppDispatch } from 'redux/store'
import { setAcademicYear, setGradeLevel, setMentor, trackActiveFilters } from 'redux/ui/groupsUI'

import SelectField from 'components/atoms/fields/SelectField'

import formModel from 'utils/tableFilterModels/groupsTableFilterModel'
import { gradeSelectData, academicYearSelectData } from 'utils/helpers'

const ExtraFiltersGroups = () => {
  const dispatch = useDispatch<AppDispatch>()

  const { academic_year, grade_level, mentor } = formModel()

  return (
    <>
      <Grid item xs={12} md={4}>
      <SelectField
          renderChildren={false}
          fieldProps={{ ...grade_level }}
          apiCall={gradeSelectData}
          onChange={(value: { id: any }) => {
            dispatch(setGradeLevel(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectField
          renderChildren={false}
          fieldProps={{ ...academic_year }}
          apiCall={academicYearSelectData}
          onChange={(value: { id: any }) => {
            dispatch(setAcademicYear(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
      <SelectField
          fieldProps={{ ...mentor }}
          apiCall={useGET_teacherProfileSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setMentor(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
    </>
  )
}
export default ExtraFiltersGroups